<template>
  <div>
    <show-finally :task="task" loader>
      <q-banner v-if="!paymentMethods.length" class="bg-yellow-3" inline-actions rounded>
        No payment method found.
        <template v-slot:action>
          <add-payment-method-btn
            :customer-id="customerId"
            color="white"
            text-color="black"
            @added="addPaymentMethod"
          />
        </template>
      </q-banner>
    </show-finally>
    <select-payment-method
      v-if="paymentMethods.length"
      :customer-id="customerId"
      :model-value="paymentMethodId"
      outlined
      @update:modelValue="$emit('update:modelValue', $event)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ShowFinally from '@/components/task/ShowFinally.vue';
import paymentMethodRepository from '@/payment-method/paymentMethodRepository';
import { PaymentMethod } from '@/type';
import AddPaymentMethodBtn from '@/payment-method/AddPaymentMethodBtn.vue';
import SelectPaymentMethod from '@/payment-method/SelectPaymentMethod.vue';

interface Data {
  paymentMethods: PaymentMethod[],
  task: Promise<PaymentMethod[]>|null,
}

export default defineComponent({
  emits: ['update:modelValue'],
  components: { ShowFinally, AddPaymentMethodBtn, SelectPaymentMethod },
  props: {
    customerId: {
      type: Number,
      required: true,
    },
    paymentMethodId: Number,
  },
  data(): Data {
    return {
      paymentMethods: [],
      task: null,
    };
  },
  watch: {
    customerId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    load() {
      this.task = paymentMethodRepository.findAll(this.customerId);
      this.task.then((paymentMethods: PaymentMethod[]) => {
        this.paymentMethods = paymentMethods;
      });
    },
    addPaymentMethod(paymentMethod: PaymentMethod) {
      this.paymentMethods.push(paymentMethod);
      this.$emit('update:modelValue', paymentMethod.id);
    },
  },
});
</script>
